import { API_CATEGORIES, MMB_KEYS, MMBKeys } from "./booking"

export const ADDITIONAL_SERVICES_ALLOWED_TO_CHANGE_CONFIG = 48

export type ViaSupportCategory =
  | "allocated_seating"
  | "sports_equipment"
  | "travelling_with_pets"
  | "musical_equipment"

export type Category =
  | ViaSupportCategory
  | "baggage"
  | "insurance"
  | "change_flights"
  | "special_assistance"
  | "accommodation"
  | "car_rental"
  | "transfer"
  | "airport_parking"
  | "price_change"
  | "scheduleChange"
  | "extra"
  | "passenger_edit"
  | "assisted_refund"
  | "meals_on_board"
  | "priority_boarding"
  | "infant"
  | "processing_fee" // NEST MAMBO
  | "service_package"
  | "passenger_details_change"
  | "booking_restore"
  | "other"
  | "flight_change"
  | "cover_more"
  | "axa_us"
  | "guides"
  | "guarantee"

// Order matters
export const SERVICES: Partial<Record<MMBKeys, Category>> = Object.freeze({
  [MMB_KEYS.BAGGAGE]: "baggage",
  [MMB_KEYS.SEATING]: "allocated_seating",
  [MMB_KEYS.INSURANCE]: "insurance",
  [MMB_KEYS.ACCOMMODATION]: "accommodation",
  [MMB_KEYS.AIRPORT_PARKING]: "airport_parking",
  [MMB_KEYS.MEALS]: "meals_on_board",
  [MMB_KEYS.TRANSFER]: "transfer",
  [MMB_KEYS.SPECIAL_ASSISTANCE]: "special_assistance",
  [MMB_KEYS.SPORTS_EQUIPMENT]: "sports_equipment",
  [MMB_KEYS.PETS]: "travelling_with_pets",
  [MMB_KEYS.MUSICAL_EQUIPMENT]: "musical_equipment",
  [MMB_KEYS.CAR_RENTAL]: "car_rental",
  [MMB_KEYS.SERVICE_PACKAGE]: "service_package",
  // statuses - not displayed
  [MMB_KEYS.EXTRA]: "extra",
  [MMB_KEYS.PRICE_CHANGE]: "price_change",
  [MMB_KEYS.SCHEDULE_CHANGE]: "scheduleChange",
  [MMB_KEYS.CHANGE_FLIGHTS]: "change_flights",
  [MMB_KEYS.PASSENGER_EDIT]: "passenger_edit",
  [MMB_KEYS.ASSISTED_REFUND]: "assisted_refund",
  [MMB_KEYS.PRIORITY_BOARDING]: "priority_boarding",
  [MMB_KEYS.INFANT]: "infant",
  [MMB_KEYS.PROCESSING_FEE]: "processing_fee",
  [MMB_KEYS.DISRUPTION_PROTECTION]: "guarantee",
  // NEST MAMBO
  [MMB_KEYS.NEST_PASSENGER_CHANGE]: "passenger_details_change",
  [MMB_KEYS.NEST_BOOKING_RESTORE]: "booking_restore",
  [MMB_KEYS.NEST_OTHER]: "other",
  [MMB_KEYS.NEST_CHANGE_FLIGHTS]: "flight_change",
  [MMB_KEYS.COVER_MORE]: "cover_more",
  [MMB_KEYS.AXA_US]: "axa_us",
  [MMB_KEYS.GUIDES]: "guides",
})

export type Service = typeof SERVICES[keyof typeof SERVICES]

export const API_CATEGORIES_TO_SERVICES = Object.freeze({
  [API_CATEGORIES.ASSISTED_REFUND]: SERVICES.ASSISTED_REFUND,
  [API_CATEGORIES.BAGS]: SERVICES.BAGGAGE,
  [API_CATEGORIES.PRIORITY_BOARDING]: SERVICES.PRIORITY_BOARDING,
  [API_CATEGORIES.EXTRAS_BAGS]: SERVICES.BAGGAGE,
  [API_CATEGORIES.FLIGHTS]: SERVICES.CHANGE_FLIGHTS,
  [API_CATEGORIES.CARRIER_ITINERARY_CHANGE]: SERVICES.CHANGE_FLIGHTS,
  [API_CATEGORIES.PASSENGER_EDIT]: SERVICES.PASSENGER_EDIT,
  [API_CATEGORIES.PRICE_CHANGE]: SERVICES.PRICE_CHANGE,
  [API_CATEGORIES.SEATING]: SERVICES.SEATING,
  [API_CATEGORIES.SERVICE_BAGGAGE]: SERVICES.BAGGAGE,
  [API_CATEGORIES.SERVICE_INFANT]: SERVICES.INFANT,
  [API_CATEGORIES.SERVICE_MEALS_ON_BOARD]: SERVICES.MEALS,
  [API_CATEGORIES.SERVICE_MUSICAL_EQUIPMENT]: SERVICES.MUSICAL_EQUIPMENT,
  [API_CATEGORIES.SERVICE_OTHER]: SERVICES.EXTRA,
  [API_CATEGORIES.SERVICE_PETS]: SERVICES.PETS,
  [API_CATEGORIES.SERVICE_PRIORITY_BOARDING]: SERVICES.PRIORITY_BOARDING,
  [API_CATEGORIES.SERVICE_SEATING]: SERVICES.SEATING,
  [API_CATEGORIES.SERVICE_SPECIAL_ASSISTANCE]: SERVICES.SPECIAL_ASSISTANCE,
  [API_CATEGORIES.SERVICE_SPORTS_EQUIPMENT]: SERVICES.SPORTS_EQUIPMENT,
  [API_CATEGORIES.UPDATE_INSURANCES]: SERVICES.INSURANCE,
  [API_CATEGORIES.HANDLING_FEE]: SERVICES.PROCESSING_FEE,
  [API_CATEGORIES.DISRUPTION_PROTECTION]: SERVICES.DISRUPTION_PROTECTION,
  // NEST MAMBO
  [API_CATEGORIES.NEST_BOOKING_RESTORE]: SERVICES.NEST_BOOKING_RESTORE,
  [API_CATEGORIES.NEST_OTHER]: SERVICES.NEST_OTHER,
  [API_CATEGORIES.NEST_PASSENGER_CHANGE]: SERVICES.NEST_PASSENGER_CHANGE,
  [API_CATEGORIES.NEST_CHANGE_FLIGHTS]: SERVICES.NEST_CHANGE_FLIGHTS,
  [API_CATEGORIES.COVER_MORE]: SERVICES.COVER_MORE,
  [API_CATEGORIES.SERVICE_PACKAGE]: SERVICES.SERVICE_PACKAGE,
})

export type BackendCategory = typeof API_CATEGORIES[keyof typeof API_CATEGORIES]

export type ApiCategoriesToServices = typeof API_CATEGORIES_TO_SERVICES[keyof typeof API_CATEGORIES_TO_SERVICES]

export const SERVICES_STATUSES = Object.freeze({
  CANCELLED: "cancelled",
  CLOSED: "closed",
  CONFIRMED: "confirmed",
  EXPIRED: "expired",
  // INTEREST: "interest",
  OFFERED: "offered",
  OPEN: "open",
  PENDING: "pending",
  REFUNDED: "refunded",
  CREATED: "created", // custom status used only on frontend during payment
})

export const SERVICE_STATUS_TITLE_KEYS = {
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.CANCELLED]: __("account.change_status_cancelled"),
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.CLOSED]: __("account.change_status_processing"),
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.CONFIRMED]: __("account.change_status_confirmed"),
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.EXPIRED]: __("account.change_status_expired"),
  // [SERVICES_STATUSES.INTEREST]: __("booking.additional_services.statuses.interest.title"), // TODO: translate once backend supports requested Meals, Equipment etc.
  // translation: Service Requested
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.OFFERED]: __("booking.additional_services.statuses.offer.title"), // shouldn't be used anymore
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.OPEN]: __("account.change_status_open"),
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.PENDING]: __("account.change_status_processing"),
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.REFUNDED]: __("booking.additional_services.statuses.refunded.title"),
  [SERVICES_STATUSES.CREATED]: "Created", // placeholder for flow, not used
} as const

export const SERVICE_STATUS_DESCRIPTION_KEYS = {
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.CANCELLED]: __("booking.additional_services.statuses.cancelled.description"),
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.CLOSED]: __("booking.additional_services.statuses.pending.description"), // same as pending for now
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.CONFIRMED]: __("booking.additional_services.statuses.confirmed.description"),
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.EXPIRED]: __("booking.additional_services.statuses.expired.description"),
  // [SERVICES_STATUSES.INTEREST]: __("booking.additional_services.statuses.interest.description"), // TODO: translate once backend supports requested Meals, Equipment etc.
  // translation: Additional service was requested. We’ll let you know within 72 hours.
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.OFFERED]: __(
    "booking.additional_services.statuses.offer.dynamic_expiration.description",
  ),
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.OPEN]: __(
    "booking.additional_services.statuses.open.dynamic_expiration.description",
  ),
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.PENDING]: __("booking.additional_services.statuses.pending.description"),
  // @ts-expect-error: Flow to TS migration.
  [SERVICES_STATUSES.REFUNDED]: __("booking.additional_services.statuses.refunded.description"),
  [SERVICES_STATUSES.CREATED]: "Created", // placeholder for flow, not used
} as const

export const DEFAULT_EXTRAS_EXPIRATION_TIME = 24
